<div class="container">
    <div class="row ">
        <div class="col-md-6 offset-md-3 " style="margin-top: 220px">
            <mat-card class="example-card box-shadow text-center p-6">
                {{approval_message}}
                <div class="row" *ngIf="!approval_message">
                    <div #jobs_section class="col-md-12 text-center">
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
</div>